var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortgage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.773 84.0708V138.059H18.584V84.0866L61.6864 41.4869L104.773 84.0708Z",
    fill: "#E1EFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.216 89.7667C117.579 92.4421 113.275 92.4679 110.6 89.8312L61.6806 41.506L12.7475 89.8309C10.0804 92.4717 5.76434 92.4497 3.13172 89.7664C0.495005 87.1042 0.52108 82.8002 3.19618 80.1635L56.8982 27.108C59.5478 24.4974 63.8129 24.4974 66.4496 27.108L120.165 80.1635C122.827 82.8002 122.853 87.1042 120.216 89.7667Z",
    fill: "#DC143C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.584 133.347H104.773V138.059H18.584V133.347Z",
    fill: "#CCDFED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.533 142.01C115.533 144.225 113.743 145.976 111.58 145.976H11.7708C9.59497 145.976 7.81812 144.199 7.81812 142.01C7.81812 139.838 9.58384 138.057 11.7708 138.057H111.58C113.769 138.058 115.533 139.821 115.533 142.01Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6285 86.1448V120.168C84.6285 123.451 81.9739 126.105 78.6909 126.105H44.6676C41.3846 126.105 38.73 123.451 38.73 120.168V86.1448C38.73 82.8617 41.3846 80.2072 44.6676 80.2072H78.6906C81.9739 80.2069 84.6285 82.8614 84.6285 86.1448Z",
    fill: "#0ABAB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1952 26.75V31.2436C41.1952 32.4928 40.1909 33.5097 38.942 33.5097H18.097C16.8478 33.5097 15.8438 32.4925 15.8438 31.2436V26.75C15.8438 25.5011 16.8478 24.4839 18.097 24.4839H38.942C40.1909 24.4842 41.1952 25.5014 41.1952 26.75Z",
    fill: "#DC143C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.41 35.3768L116.46 121.031C115.188 124.44 111.402 126.168 107.978 124.895L104.773 123.686V84.0867L110.601 89.8359C113.272 92.4594 117.576 92.4433 120.214 89.7732C122.853 87.1028 122.822 82.7988 120.167 80.1597L109.658 69.7924L86.4263 46.8275L68.2209 28.8577L70.0274 24.0193L75.902 8.31206C77.1586 4.91918 80.9598 3.17573 84.3688 4.43227L144.546 26.8945C147.954 28.1665 149.682 31.9678 148.41 35.3768Z",
    fill: "#0ABAB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.278 37.3784L86.0149 19.7455C85.2019 19.4417 84.7894 18.5373 85.0929 17.7246C85.3952 16.9116 86.2999 16.4991 87.1132 16.8021L134.376 34.4353C135.189 34.7391 135.602 35.6435 135.298 36.4562C134.997 37.2671 134.093 37.6825 133.278 37.3784Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.595 49.9304L81.3318 32.2981C80.5188 31.9943 80.1063 31.0899 80.4098 30.2772C80.7121 29.4642 81.62 29.0508 82.4301 29.3547L129.693 46.987C130.506 47.2908 130.919 48.1952 130.615 49.0079C130.314 49.8188 129.41 50.2342 128.595 49.9304Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.924 61.5615C125.62 62.3719 124.724 62.7832 123.913 62.4882L89.1363 49.5293L85.3037 45.728C85.7279 45.288 86.3719 45.131 86.969 45.3513L124.998 59.5354C125.815 59.8497 126.238 60.745 125.924 61.5615Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1086 80.2069H63.2501V126.105H60.1086V80.2069Z",
    fill: "#E1EFFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.73 101.585H84.6282V104.727H38.73V101.585Z",
    fill: "#E1EFFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.1666 46.6077L19.8723 63.6822V57.0693L37.1666 39.979V46.6077Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.56 93.0876C119.119 97.5928 111.817 97.6467 107.287 93.1819L104.773 90.6999L61.6864 48.1315L18.584 90.684V84.0867L61.6864 41.487L104.773 84.0709V84.0867L110.601 89.8359C113.271 92.4594 117.575 92.4433 120.214 89.7732C122.853 87.1028 122.821 82.7988 120.167 80.1597L109.658 69.7924L86.4259 46.8275L68.2205 28.8577L70.027 24.0193L123.481 76.8134C127.989 81.2751 128.021 88.5794 123.56 93.0876Z",
    fill: "#CCDFED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.1666 33.5073V46.6077L19.8723 63.6822V33.5073H37.1666Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8723 33.5073H37.1666V38.2197H19.8723V33.5073Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgage);
export default __webpack_public_path__ + "static/media/mortgage.7fd87731ef6ad907b04274c1a6f1f78f.svg";
export { ForwardRef as ReactComponent };